<ng-template #ModalDownload>
  <div class="modal-content">
    <div class="modal-header">
      <a>Download</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>

    <div class="modal-body text-center p-5">
      <span class="div__span">Autorizar Download</span>
      <p class="div__p">Deseja continuar e realizar o download do boleto "{{boleto.codFatura}}" ?</p>
      <div class="div-button mt-5">
        <button (click)="doDownload()" class="button-primary">
          Sim
        </button>
        <button (click)="fecharModal()" class="button-primary">
          Não
        </button>
      </div>
    </div>
  </div>
</ng-template>